 

import { createContext, useContext, useState } from 'react'
import { ToastContent } from './Toast'

export type ToastContextType = {
  toastContent: ToastContent | null,
  setToastContent: React.Dispatch<React.SetStateAction<ToastContent | null>>,
}

export const ToastContext = createContext<ToastContextType>({
  toastContent: null,
  setToastContent: () => { },
})

export const useToastContext = () => {
  const context = useContext(ToastContext)

  if (context === undefined) {
    throw new Error(
      'useToastContext must be used within a ToastContextProvider',
    )
  }

  return context
}

export const useToastState = () => {
  const [toastContent, setToastContent] = useState<ToastContent | null>(null)

  return {
    toastContent,
    setToastContent,
  }
}
